import React from 'react';
import {LinkpileComponent as Linkpile} from '../../components/common/linkpile/Linkpile';

export function LinkPilesComponent({linkPiles}) {
    return (
        <>
            {linkPiles?.length > 0 &&
                linkPiles.map(({heading, hideTabs = true, tabs}, index) => {
                    return (
                        <Linkpile
                            heading={heading}
                            hideTabs={hideTabs}
                            tabs={tabs}
                            key={`linkpile-${index}`}
                        />
                    );
                })}
        </>
    );
}

export default LinkPilesComponent;
